export default function componentStyleOverrides(theme) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '6px'
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: '24px'
                },
                title: {
                    fontSize: '1.125rem'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '20px'
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.textDark
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    '&::placeholder': {
                        color: theme.darkTextSecondary,
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    boxSizing: 'content-box',
                    background: '#fff',
                    borderRadius: '5px !important',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.colors?.grey400,
                        borderRadius: '5px !important'
                    },
                    '&:hover $notchedOutline': {
                        borderColor: theme.colors?.primaryLight
                    },
                    '&.MuiInputBase-multiline': {
                        padding: 1
                    },
                },
                input: {
                    boxSizing: 'content-box',
                    fontWeight: 500,
                    background: 'transparent',
                    padding: '15.5px 14px',
                    borderRadius: '5px !important',
                    '&.MuiInputBase-inputSizeSmall': {
                        boxSizing: 'content-box',
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
                notchedOutline: {
                    borderRadius: '12px'
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper,
                    background: theme.colors?.grey700
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'small',
                fullWidth: true
            },
        },
        MuiFormControl: {
            defaultProps: {
                variant: 'outlined',
            },
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fff'
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    padding: 0,
                    listStyles: 'none',
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-sizeSmall': {
                        boxSizing: 'border-box',
                        padding: '7.5px 14px !important',
                    }
                }
            }
        },
        RaSidebar: {
            styleOverrides: {
                root: {
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    minHeight: `calc(100vh - 3em)`
                }
            }
        },
        RaCreate: {
            styleOverrides: {
                root: {
                    marginLeft: '16px',
                    marginRight: '8px',
                    marginTop: '30px',
                    marginBottom: '30px',
                    '& .RaCreate-main': {
                        marginTop: 0
                    }
                },
            }
        },
        RaEdit: {
            styleOverrides: {
                root: {
                    marginLeft: '16px',
                    marginRight: '8px',
                    marginTop: '30px',
                    marginBottom: '30px',
                    '& .RaEdit-main': {
                        marginTop: 0
                    }
                },
            }
        },
        RaTextIntput: {
            defaultProps: {
                alwaysOn: true
            }
        },
        RaLayout: {
            styleOverrides: {
                root: {
                    '& .RaLayout-appFrame': {
                        marginTop: '88px'
                    },
                    '& .RaLayout-content': {
                        borderRadius: '12px',
                        marginRight: '20px',
                        backgroundColor: theme.colors?.primaryLight
                    }
                }
            }
        },
        RaAppBar: {
            styleOverrides: {
                root: {
                    padding: '16px 16px'
                }
            }
        },
        RaMenuItemLink: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected
                    },
                    '&.RaMenuItemLink-active': {
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack,
                            color: theme.menuSelected
                        },
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected
                    },
                    '& .RaMenuItemLink-icon': {
                        color: "inherit",
                    },
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    marginBottom: '4px'
                }
            }
        },
        RaSidebarToggleButton: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.menuSelectedBack,
                    '&:hover': {
                        backgroundColor: theme.menuSelected,
                        color: theme.menuSelectedBack
                    }
                }
            }
        },
        RaAutocompleteInput: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-sizeSmall': {
                        padding: '7.5px 14px !important',
                    }
                }
            }
        },
        RaListToolbar: {
            styleOverrides: {
                root: {
                    marginBottom: '12px'
                }
            }
        },
        RaLoadingIndicator: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryMain
                }
            }
        }
    };
}
